import { render, staticRenderFns } from "./PWSFiles.vue?vue&type=template&id=3ead2656&"
import script from "./PWSFiles.vue?vue&type=script&lang=js&"
export * from "./PWSFiles.vue?vue&type=script&lang=js&"
import style0 from "./PWSFiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports